export default "__VITE_ASSET__CO_w5frM__"